







































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import teamsAPI from "@/api/teams";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";

/**
 * VueX Modules
 */
const teamModule = namespace("team");


/**
 * Invite people in team modal.
 */
@Component
export default class InvitePeopleDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections

	/// Properties

	/// Attributes
	isLoading = false;
	inviteLinks: any[] | null = null;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	/// Methods
	async open() {
		this.isLoading = true;
		this.$refs.modal.open();
		await this.fetchInviteLinks();
		this.isLoading = false;
	}

	close() {
		this.$refs.modal.close();
	}

	async fetchInviteLinks() {
		this.inviteLinks = await teamsAPI.fetchInviteLinks(this.currentTeam.id);
	}

	handleCopyClick(inviteCode: string) {
		const inviteLink = `${window.location.origin}/invite/${inviteCode}`;
		navigator.clipboard.writeText(inviteLink);
		this.$snackbar.openInfo(this.$t("snackbar.copied_to_clipboard"));
	}

	async handleCreateLinkClick() {
		this.isLoading = true;
		try {
			await teamsAPI.createInviteLink(this.currentTeam.id);
			this.$snackbar.openInfo(this.$t("snackbar.success"));
			await this.fetchInviteLinks();
		}
		catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleDeleteLinkClick(linkID: any) {
		this.isLoading = true;
		try {
			await teamsAPI.deleteInviteLink(linkID);
			this.$snackbar.openInfo(this.$t("snackbar.success"));
			await this.fetchInviteLinks();
		}
		catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
